import { z } from "zod";
import { photoListQuerySchema } from "@/schemas/photos";

/** The query string of `GET /api/projects/:id/pins`: the album and date filters of the photo list. */
export const pinsQuerySchema = photoListQuerySchema.pick({ album: true, from: true, to: true });

const latLngSchema = z.object({ lat: z.number(), lng: z.number() });

/**
 * Pins carry an id and a position and nothing else: the picture is fetched when one is
 * opened, through `/files`, which checks access.
 */
const pinSchema = latLngSchema.extend({ id: z.string() });

export const pinsResponseSchema = z.object({
  /** Photos with a GPS fix of their own. */
  pins: z.array(pinSchema),
  /** Pictures in this filter with a file and no GPS fix, whether or not they can be drawn. */
  noLocation: z.number(),
  /** Rows in this filter with no GPS fix whose file was not pulled for this POC. */
  notPulled: z.number(),
  /** Rows in this filter with no GPS fix whose file is not a picture. */
  notImages: z.number(),
  /** Those pictures, drawn at the median of the located photos this account can see. Not a true location. */
  approximate: latLngSchema.extend({ ids: z.array(z.string()) }).nullable(),
});
export type PinsResponse = z.infer<typeof pinsResponseSchema>;
